import React from 'react';
function ViewArray() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M4 18h3V5H4v13zM18 5v13h3V5h-3zM8 18h9V5H8v13z" }),
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" })));
}
export default ViewArray;
